import { ReactNode, useEffect, useState } from "react";
import { CategoriesContext } from "./CategoriesContext";
import { CategoryData } from "../helper/interface";
import { get } from "../helper/APIClient";
import { Routes } from "../helper/Routes";
import { sortByText } from "../helper/sortOptions";

interface Props {
  children: ReactNode;
}

export const CategoriesProvider = ({ children }: Props) => {
  const [categories, setCategories] = useState<(CategoryData & { shared?: number; received?: number })[] | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await get(Routes.GET_CATEGORIES);
      setCategories(sortByText(response, (category) => category.categoryName));
    } catch (error) {
      console.error('Error fetching categories:', error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <CategoriesContext.Provider value={{ categories, loading, refreshCategories: fetchCategories }}>
      {children}
    </CategoriesContext.Provider>
  );
};
